import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: { mode: 'dark' },
  custom: {
    layers: {
      // already added for other layers in your project:
      gridOverlay:
        'linear-gradient(rgba(139,92,246,.30) 1px, transparent 1px), ' +
        'linear-gradient(90deg, rgba(139,92,246,.30) 1px, transparent 1px)',
      gradientBlob:
        'radial-gradient(circle at 30% 30%, rgba(168,85,247,.60), rgba(168,85,247,0) 60%)',
      gradientBlobAlt:
        'radial-gradient(circle at 70% 70%, rgba(236,72,153,.55), rgba(236,72,153,0) 60%)',

      // ✅ Add this to stop ParticlesLayer from crashing
      particle: {
        colorA: '#a855f7',      // purple
        colorB: '#ec4899',      // pink
        blur: 6,
        boxShadow: '0 0 0 1px rgba(255,255,255,.1), 0 0 24px rgba(168,85,247,.3)',
        sizeMin: 6,
        sizeMax: 20,
        floatMin: 8,
        floatMax: 18
      }
    }
  },
  // palette: {
  //   mode: 'dark',
  //   primary: {
  //     main: '#a855f7',
  //     light: '#c084fc',
  //     dark: '#7e22ce',
  //   },
  //   secondary: {
  //     main: '#ec4899',
  //     light: '#f472b6',
  //     dark: '#be185d',
  //   },
  //   background: {
  //     default: '#0b0f1a',
  //     paper: 'rgba(255, 255, 255, 0.06)',
  //   },
  //   text: {
  //     primary: '#ffffff',
  //     secondary: '#e2e8f0',
  //   },
  // },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 800,
      fontSize: 'clamp(2.5rem, 5vw + 1rem, 4rem)',
      lineHeight: 1.2,
      background: 'linear-gradient(135deg, #a855f7 0%, #ec4899 100%)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      backgroundClip: 'text',
    },
    h2: {
      fontWeight: 700,
      fontSize: 'clamp(2rem, 4vw + 1rem, 3rem)',
      lineHeight: 1.3,
    },
    h3: {
      fontWeight: 600,
      fontSize: 'clamp(1.5rem, 3vw + 1rem, 2.25rem)',
      lineHeight: 1.4,
    },
    body1: {
      fontSize: '1rem',
      lineHeight: 1.7,
    },
    body2: {
      fontSize: '0.875rem',
      lineHeight: 1.6,
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          background: 'linear-gradient(180deg, #0b0f1a 0%, #0e1424 50%, #111827 100%)',
          minHeight: '100vh',
          overflowX: 'hidden',
          WebkitOverflowScrolling: 'touch',
          willChange: 'auto',
        },
        html: {
          background: '#0b0f1a !important',
          scrollBehavior: 'smooth',
          margin: 0,
          padding: 0,
          minHeight: '100vh',
        },
        '#app': {
          background: '#0b0f1a !important',
          minHeight: '100vh',
        },
        '*': {
          WebkitTapHighlightColor: 'transparent',
        },
        '*::-webkit-scrollbar': {
          width: '8px',
        },
        '*::-webkit-scrollbar-track': {
          background: '#0b0f1a',
        },
        '*::-webkit-scrollbar-thumb': {
          background: 'linear-gradient(135deg, #a855f7 0%, #ec4899 100%)',
          borderRadius: '4px',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: '12px',
          padding: '12px 32px',
          fontWeight: 600,
          fontSize: '1rem',
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          background: 'rgba(255, 255, 255, 0.06)',
          border: '1px solid rgba(255, 255, 255, 0.18)',
          backdropFilter: 'blur(10px)',
          borderRadius: '16px',
          boxShadow: 'none',
        },
      },
    },
  },
  shape: {
    borderRadius: 12,
  },
});

export default theme;

// import { createTheme } from '@mui/material/styles';

//  const theme = createTheme({
//   palette: { mode: 'dark' },
//   custom: {
//     layers: {
//       // already added for other layers in your project:
//       gridOverlay:
//         'linear-gradient(rgba(139,92,246,.30) 1px, transparent 1px), ' +
//         'linear-gradient(90deg, rgba(139,92,246,.30) 1px, transparent 1px)',
//       gradientBlob:
//         'radial-gradient(circle at 30% 30%, rgba(168,85,247,.60), rgba(168,85,247,0) 60%)',
//       gradientBlobAlt:
//         'radial-gradient(circle at 70% 70%, rgba(236,72,153,.55), rgba(236,72,153,0) 60%)',

//       // ✅ Add this to stop ParticlesLayer from crashing
//       particle: {
//         colorA: '#a855f7',      // purple
//         colorB: '#ec4899',      // pink
//         blur: 6,
//         boxShadow: '0 0 0 1px rgba(255,255,255,.1), 0 0 24px rgba(168,85,247,.3)',
//         sizeMin: 6,
//         sizeMax: 20,
//         floatMin: 8,
//         floatMax: 18
//       }
//     }
//   }
// });
// export default theme;